import {
    CompositePropagator,
    W3CBaggagePropagator,
    W3CTraceContextPropagator,
} from '@opentelemetry/core';
import { BatchSpanProcessor, ConsoleSpanExporter, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { SimpleSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
//import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { trace, context, diag, DiagConsoleLogger, DiagLogLevel, SpanKind, propagation, Span } from '@opentelemetry/api';
import { AzureMonitorTraceExporter } from "@azure/monitor-opentelemetry-exporter";
//Copy paste it ? https://github.com/Azure/azure-sdk-for-js/blob/98601258d719ca00aa2a2772f36ccf78f9b803ac/sdk/monitor/monitor-opentelemetry-exporter/src/export/trace.ts#L17


diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.INFO);

const FrontendTracer = async () => {
    const { ZoneContextManager } = await import('@opentelemetry/context-zone');

    const provider = new WebTracerProvider({
        resource: new Resource({
            [SemanticResourceAttributes.SERVICE_NAME]:
                process.env.NEXT_PUBLIC_OTEL_SERVICE_NAME,
            [SemanticResourceAttributes.SERVICE_NAMESPACE]: "hafnia"
        }),
    });

    const exporter = new ConsoleSpanExporter();
    const processor = new BatchSpanProcessor(exporter);
    provider.addSpanProcessor(processor);

    //// Create an exporter instance
    //const azure_exporter = new AzureMonitorTraceExporter({
    //    connectionString:
    //        process.env["NEXT_PUBLIC_AZUREMONITOR_CONNECTION_STRING"]
    //});

    //// Add the exporter to the provider
    //provider.addSpanProcessor(
    //    new BatchSpanProcessor(azure_exporter, {
    //        bufferTimeout: 15000,
    //        bufferSize: 1000
    //    })
    //);

    const contextManager = new ZoneContextManager();

    provider.register({
        contextManager,
        propagator: new CompositePropagator({
            propagators: [
                new W3CBaggagePropagator(),
                new W3CTraceContextPropagator(),
            ],
        }),
    });

    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            new FetchInstrumentation({
                propagateTraceHeaderCorsUrls: /.*/,
                clearTimingResources: true,
                applyCustomAttributesOnSpan(span) {
                    span.setAttribute('app.synthetic_request', 'false');
                },

            }),
            new DocumentLoadInstrumentation()
            //getWebAutoInstrumentations({
            //    '@opentelemetry/instrumentation-fetch': {
            //        propagateTraceHeaderCorsUrls: /.*/,
            //        clearTimingResources: true,
            //        applyCustomAttributesOnSpan(span) {
            //            span.setAttribute('app.synthetic_request', 'false');
            //        },

            //    },
            //}),
        ],
    });
};

export default FrontendTracer;